import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";
import { mutations } from "@/apollo";
import { clone } from "lodash";
import { errorMutationNotification } from "@/utils";
import { onMounted, ref, watch } from "vue";
import { apolloClient } from "@/apollo";
import { addErrorToast, addSuccessToast } from "@/vue-service";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePasswordFormModal',
  props: {
    user: null,
    value: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { user: User, value: boolean };

const form = ref(getDefaultForm());



const { $t } = useTranslation();

onMounted(() => {
  form.value = getDefaultForm();
})

function toggleModal(val: boolean) {
  emit("input", val);
}

function getDefaultForm() {
  return clone({
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: ""
  });
}

function resetForm() {
  form.value = getDefaultForm();
}

watch(() => (props.user), () => {
  resetForm();
})

async function handleSubmit() {
  if (form.value.newPassword !== form.value.confirmNewPassword) {
    addErrorToast("New password and confirm password does not match");
    return;
  }
  try {
    const result = await apolloClient.mutate({
      mutation: mutations.changePassword,
      variables: {
        behalfOf: props.user.userId,
        oldPassword: form.value.oldPassword,
        newPassword: form.value.newPassword
      }
    });
    addSuccessToast("Password changed");
    resetForm();
    toggleModal(false);
  } catch (err) {
    errorMutationNotification(err);
  }
}


return { __sfc: true,form, props, emit, $t, toggleModal, getDefaultForm, resetForm, handleSubmit }
}

})